import { memo } from 'react';

import { Spinner } from '@air/primitive-spinner';

export const SkipOnboardingLoadingOverlay = memo(() => {
  return (
    <div
      role="status"
      aria-label="Loading"
      className="fixed inset-0 z-50 flex items-center justify-center ads:bg-base bg-gray-1"
    >
      <Spinner className="size-10 ads:text-ads-cyan-10 text-teal-9" />
    </div>
  );
});

SkipOnboardingLoadingOverlay.displayName = 'SkipOnboardingLoadingOverlay';
